import { GET_EMPLOYEES_LEAVES } from "../../../enums/Employees/employees.types";

export const getEmployeesLeavesAction = (leavesAndDailyPercent) => {
    return {
        type: GET_EMPLOYEES_LEAVES,
        payload: leavesAndDailyPercent,
    };
};